type ArrowProps = {
  size?: number;
  strokeWidth?: number;
};

const SHARED: React.SVGProps<SVGSVGElement> = {
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  "aria-hidden": true,
};

export function ArrowRight({ size = 16, strokeWidth = 2.2 }: ArrowProps) {
  return (
    <svg width={size} height={size} strokeWidth={strokeWidth} {...SHARED}>
      <path d="M5 12h14M13 6l6 6-6 6" />
    </svg>
  );
}

export function ArrowLeft({ size = 14, strokeWidth = 2.2 }: ArrowProps) {
  return (
    <svg width={size} height={size} strokeWidth={strokeWidth} {...SHARED}>
      <path d="M19 12H5M11 18l-6-6 6-6" />
    </svg>
  );
}
